import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';


@Component({
  selector: 'app-location-management',
  templateUrl: './location-management.component.html',
  styleUrls: ['./location-management.component.css']
})
export class LocationManagementComponent implements OnInit {
  @Input() headings: any[] = [];
  locationForm: FormGroup;
  locationType: string;
  isEdit: boolean = false;
  Edit: boolean = false;
  rowData: any;
  accountTypes: any[] = []; 
  isViewMode: boolean = false;
  accountTypeData: any[] = [];
  imageUrl: string | null = null;
  invalidFileType = false;
  fileType = '';
  fileError: boolean = false;
  fileName = 'Select File';
  payload: any = {};

  constructor(
    private dialogRef: MatDialogRef<LocationManagementComponent>,
    private formBuilder: FormBuilder,
    private masterDataService: MasterDataService,
    private http: HttpClient,
    private allProductService: AllProductService,
    private sweetAlertService: SweetAlertService, 
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.locationType = this.data.type;
    this.headings = this.data.headings;
    this.rowData = this.data.rowData;
    this.isEdit = !!this.rowData;
    this.Edit = this.isEdit;
    this.isViewMode = this.data.viewMode || false;
    this.locationForm = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.initForm();
    if (this.isEdit) {
      this.populateForm();
    }
    if (this.locationType === 'Position' || this.locationType === 'Speciality' ) {
      this.getAccountTypes();  // Add this line
    }
    if(this.locationType === 'Account Type') {
      this.getOnboardingAccountTypes();
    }
    if(this.isViewMode) {
      this.locationForm.disable();
      this.Edit= false;
    }
   
  }

  getAccountTypes() {
    // this.masterDataService.getAccountType().subscribe(
    this.masterDataService.getOnboardingAccountTypes().subscribe(
      (data) => {
       
        this.accountTypes = data.data.map((d:any)=>d.accountType);
        if (this.isEdit) {
          this.populateAccountTypes();
        }
      },
      (error) => {
       
      }
    );
  }
  allowOnlyNumbersAndSpecialCharacters(event: KeyboardEvent): void {
    const char = event.key;
    const isAllowed = /[0-9+,\-() \[\]]/.test(char);
    if (!isAllowed) {
      event.preventDefault(); 
    }
  }
  
  getOnboardingAccountTypes() {
    this.masterDataService.getOnboardingAccountCategoryType().subscribe(
      (data) => {
      
        this.accountTypes = data.data.map((d: any) => d.name);
        this.accountTypeData = data.data
        if (this.isEdit) {
          this.populateAccountTypes();
        }
      },
      (error) => {
       
      }
    );
  }

  populateAccountTypes() {
    if (this.rowData && this.rowData.accountCategory) {
      this.locationForm.patchValue({
        accountType: this.rowData.accountType
      });
      return;
    }
    if (this.rowData && this.rowData.accountType) {
      const selectedAccountTypes = Object.values(this.rowData.accountType);
      this.locationForm.patchValue({
        accountType: selectedAccountTypes
      });
    }
    if (this.rowData && this.rowData.accountsTypes) {
      const selectedAccountTypes = Object.values(this.rowData.accountsTypes);
      this.locationForm.patchValue({
        accountsTypes: selectedAccountTypes
      });
    }
  }


  initForm() {
    const formGroupControls: { [key: string]: any } = {}; 
    this.headings.forEach(heading => {
      formGroupControls[heading.property] = ['', [Validators.required]];
    });
    if(this.locationType === 'Equipment' || this.locationType === 'Speciality' || this.locationType === 'Service' || this.locationType === 'Tests') {
      formGroupControls['imageUrl'] = ['', [Validators.required]];
      this.locationForm = this.formBuilder.group(formGroupControls);
    } else if (this.locationType === 'incoterms') {
        formGroupControls['fields'] = this.formBuilder.array([]);
        this.locationForm = this.formBuilder.group(formGroupControls);
        this.addField();
      } 
    else {
      this.locationForm = this.formBuilder.group(formGroupControls);
    }
  }

  get fields() {
    return this.locationForm.get('fields') as FormArray;
  }

  addField() {
    const fieldGroup = this.formBuilder.group({
      label: ['', Validators.required],
      dataType: ['', Validators.required],
      listOptions: ['']
    });
    
    const dataTypeControl = fieldGroup.get('dataType');
    dataTypeControl?.valueChanges.subscribe(value => {
      const listOptionsControl = fieldGroup.get('listOptions');
      if (value === 'List') {
        listOptionsControl?.setValidators([Validators.required]);
      } else {
        listOptionsControl?.clearValidators();
      }
      listOptionsControl?.updateValueAndValidity();
    });
    
    this.fields.push(fieldGroup);
  }

  removeField(index: number) {
    if (this.fields.length > 1) {
      this.fields.removeAt(index);
    }
  }

  populateForm() {
    if(this.locationType === 'Equipment' || this.locationType === 'Speciality' || this.locationType === 'Service' || this.locationType === 'Tests') {
      this.locationForm.patchValue(this.rowData);
      this.imageUrl = this.rowData?.imageUrl;
      this.fileName = this.getFileNameFromUrl(this.rowData?.imageUrl);
    } 
    else if (this.locationType === 'incoterms' && this.rowData) {
      while (this.fields.length) {
        this.fields.removeAt(0);
      }
      
      this.locationForm.patchValue({
        name: this.rowData.name
      });
      
      if (this.rowData.fields && this.rowData.fields.length) {
        this.rowData.fields.forEach((field: any) => {
          const fieldGroup = this.formBuilder.group({
            label: [field.label, Validators.required],
            dataType: [field.dataType, Validators.required],
            listOptions: [field.listOptions || '']
          });
          if (field.dataType === 'List') {
            fieldGroup.get('listOptions')?.setValidators([Validators.required]);
            fieldGroup.get('listOptions')?.updateValueAndValidity();
          }
          
          this.fields.push(fieldGroup);
        });
      } else {
        this.addField();
      }
    }else {
      this.locationForm.patchValue(this.rowData);
    }   
  }

  getFileNameFromUrl(url: string): string {
    return url ? url.split('/').pop() || '' : '';
  }

  onFormSubmit() {
    let apiCall: Observable<any> | undefined = undefined; 
  
    if (this.locationForm.valid) {
      const formData = this.locationForm.value;
      let formAccountData; 

      if (this.locationType === 'Position') {
        if (formData['accountType'] && typeof formData['accountType'] === 'string') {
          formData['accountType'] = formData['accountType'].split(',').map((type: string) => type.trim());
        }
      }
      if (this.locationType === 'Speciality') {
        if (formData['accountsTypes'] && typeof formData['accountsTypes'] === 'string') {
          formData['accountsTypes'] = formData['accountsTypes'].split(',').map((type: string) => type.trim());
        }
      }
      if (this.locationType === 'Account Type') {
        const accountType = this.accountTypeData.find((data) =>
          data.name.includes(formData?.accountCategory)
        );
        const accountTypeId = accountType ? accountType.id : null;
        formAccountData = {
          "name": formData.accountType,
          "accountType": {
            id: accountTypeId,
          }
        }
      }
      if (this.locationType === 'incoterms') {
        const processedFields = formData.fields.map((field: any) => {
          const processedField: any = {
            label: field.label,
            dataType: field.dataType
          };
          
          if (field.dataType === 'List' && typeof field.listOptions === 'string') {
            processedField.listOptions = field.listOptions
              .split(',')
              .map((option: string) => option.trim())
              .filter((option: string) => option !== '');
          } else if (field.dataType === 'List' && Array.isArray(field.listOptions)) {
            processedField.listOptions = field.listOptions;
          }
          
          return processedField;
        });
        
        this.payload = {
          name: formData.name,
          fields: processedFields
        };
      }
     if (this.isEdit) {
        if (this.locationType === 'Position') {
          if (formData['accountType']) {
            const accountTypeObject: { [key: string]: string } = {};
            formData['accountType'].forEach((type: string, index: number) => {
              accountTypeObject[index + 1] = type;
            });
            formData['accountType'] = accountTypeObject;
          }
        }
        
        if (this.locationType === 'Speciality') {
          if (formData['accountsTypes']) {
            const accountTypeObject: { [key: string]: string } = {};
            formData['accountsTypes'].forEach((type: string, index: number) => {
              accountTypeObject[index + 1] = type;
            });
            formData['accountsTypes'] = accountTypeObject;
          }
        }

        if (this.locationType === 'Account Type') {
          const accountType = this.accountTypeData.find((data) =>
            data.name.includes(formData?.accountCategory)
          );
          const accountTypeId = accountType ? accountType.id : null;
          formAccountData = {
            "name": formData.accountType,
            "accountType": {
              id: accountTypeId,
            }
          }
        }

        if (this.locationType === 'Continent') {
          apiCall = this.masterDataService.updateContinent(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Country') {
          apiCall = this.masterDataService.updateCountry(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'State') {
          apiCall = this.masterDataService.updateState(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'City') {
          apiCall = this.masterDataService.updateCity(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Account Type') {
          apiCall = this.masterDataService.updateOnboardingAccountType(this.rowData.id, formAccountData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Speciality') {
          apiCall = this.masterDataService.updateSpeciality(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Position') {
          apiCall = this.masterDataService.updatePosition(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Lead Source') {
          apiCall = this.masterDataService.updateLeadSource(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Job Category') {
          apiCall = this.masterDataService.updateJobCategory(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Job Skill') {
          apiCall = this.masterDataService.updateJobSkill(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Job Type') {
          apiCall = this.masterDataService.updateJobType(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Experience Level') {
          apiCall = this.masterDataService.updateExperience(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Degree Level') {
          apiCall = this.masterDataService.updateDegree(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Job Tag') {
          apiCall = this.masterDataService.updateJobTags(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Equipment') {
          apiCall = this.masterDataService.updateEquipments(this.rowData.id, formData, { responseType: 'text' as 'json' });
        } else if (this.locationType === 'Service') {
          apiCall = this.masterDataService.updateServices(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }  else if (this.locationType === 'Tests') {
          apiCall = this.masterDataService.updateTests(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }else if (this.locationType === 'Support Issue') {
          apiCall = this.masterDataService.updateSupportTicketIssue(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }else if (this.locationType === 'Support Priority') {
          apiCall = this.masterDataService.updateSupportTicketPriority(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }else if (this.locationType === 'Department') {
          apiCall = this.masterDataService.updateDepartment(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }else if (this.locationType === 'Salary Range') {
          apiCall = this.masterDataService.updateSalaryRange(this.rowData.id, formData, { responseType: 'text' as 'json' });
        }else if (this.locationType === 'incoterms') {
          apiCall = this.masterDataService.updateIncoterm(this.rowData.id, this.payload, { responseType: 'text' as 'json' });
        }
        
      } else {
        if (this.locationType === 'Continent') {
          apiCall = this.masterDataService.addContinent(formData, );
        } else if (this.locationType === 'Country') {
          apiCall = this.masterDataService.addCountry(formData, );
        } else if (this.locationType === 'State') {
          apiCall = this.masterDataService.addState(formData, );
        } else if (this.locationType === 'City') {
          apiCall = this.masterDataService.addCity(formData);
        } else if (this.locationType === 'Account Type') {
          apiCall = this.masterDataService.addOnboardingAccountType(formAccountData);
        } else if (this.locationType === 'Speciality') {
          apiCall = this.masterDataService.addSpeciality(formData);
        } else if (this.locationType === 'Position') {
          apiCall = this.masterDataService.addPosition(formData);
        } else if (this.locationType === 'Lead Source') {
          apiCall = this.masterDataService.addLeadSource(formData);
        } else if (this.locationType === 'Job Category') {
          apiCall = this.masterDataService.addJobCategory(formData);
        } else if (this.locationType === 'Job Skill') {
          apiCall = this.masterDataService.addJobSkill(formData);
        } else if (this.locationType === 'Job Type') {
          apiCall = this.masterDataService.addJobType(formData);
        } else if (this.locationType === 'Experience Level') {
          apiCall = this.masterDataService.addExperience(formData);
        } else if (this.locationType === 'Degree Level') {
          apiCall = this.masterDataService.addDegree(formData);
        } else if (this.locationType === 'Job Tag') {
          apiCall = this.masterDataService.addJobTags(formData);
        } else if (this.locationType === 'Equipment') {
          apiCall = this.masterDataService.addEquipments(formData);
        } else if (this.locationType === 'Service') {
          apiCall = this.masterDataService.addServices(formData);
        } else if (this.locationType === 'Tests') {
          apiCall = this.masterDataService.addTests(formData);
        } else if (this.locationType === 'Support Issue') {
          apiCall = this.masterDataService.addSupportTicketIssue(formData);
        }else if (this.locationType === 'Support Priority') {
          apiCall = this.masterDataService.addSupportTicketPriority(formData);
        }else if (this.locationType === 'Department') {
          apiCall = this.masterDataService.addDepartment(formData);
        }else if (this.locationType === 'Salary Range') {
          apiCall = this.masterDataService.addSalaryRange(formData);
        }else if (this.locationType === 'incoterms') {
          apiCall = this.masterDataService.addIncoterm(this.payload);
        }
      }
  
      if (apiCall) {
        apiCall.subscribe(
          (response) => {
            this.sweetAlertService.showSuccess('', this.isEdit ? 'Updated successfully!' : 'Added successfully !!').then(()=>{
              this.dialogRef.close(true);
            });
            
          },
          (error) => {
           
            Swal.fire('Error', this.isEdit ? 'Failed to update . Please try again later.' : 'Failed to add. Please try again later.', 'error');
          }
        );
      }
    } else {
     
      Swal.fire('Error', 'Please fill in all required fields', 'error');
    }
  }

  selectFile(event: any): void {
    if (event.target.files && event.target.files[0]) {
      if(!event.target.files[0].type.includes('image/')){
        this.fileType = event.target.files[0].type;
        this.invalidFileType = true;
        return;
      }
      this.fileError = false;
      this.invalidFileType = false
      const file: File = event.target.files[0];
      this.fileName = file.name;
      let uploadData = new FormData();
      uploadData.append('file', file);
      uploadData.append('destinationKey','');
      this.allProductService.uploadFile(MweConstants.uploadFile, uploadData).subscribe(data=>{
        if(data && data?.data){
          this.imageUrl = data.data;
          this.locationForm.get('imageUrl')?.setValue(data.data);
        }
      },error=>{
        this.sweetAlertService.showError('', 'Failed to upload file !!');
      });
    } else {
      this.fileName = 'Select File';
    }
  }
  deleteFile () {
    this.imageUrl = null;
    this.locationForm.get('imageUrl')?.setValue('');
    this.fileName = 'Select File';
  }
}
